import { apiRequest } from "./baseApi";
import { parseJsonOrThrow } from "./responseUtils";

/**
 * GMA-875 — client weather + hazards for the caregiver client-profile card.
 * Backend returns BOTH current-conditions sources (Apple WeatherKit REST + NWS)
 * so they can be compared, plus the client's active hazard alerts, all keyed
 * off the client's stored location.
 * GET /api/v1/users/:id/weather -> { location, apple, nws, alerts }
 */
export const fetchClientWeather = async (clientId) => {
  const res = await apiRequest(`users/${clientId}/weather`, { version: "v1" });
  return parseJsonOrThrow(res, "Client weather");
};
